var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-collapse',{attrs:{"id":'accordion-'+_vm.keyID,"accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_c('h4',[_vm._v(_vm._s(this.answer.answers[0].body))])]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.doCopy}},[_vm._v("Copy")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }